import { useEffect } from 'react'
import { View } from 'react-native'
import Animated, {
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated'

type Props = {
  progress: number
  isPulsing?: boolean
  className?: string
}

export function ProgressBar({
  progress,
  isPulsing = false,
  className = 'h-2 overflow-hidden rounded-full bg-black/10',
}: Props) {
  const fillOpacity = useSharedValue(1)

  useEffect(() => {
    if (!isPulsing) {
      fillOpacity.set(withTiming(1, { duration: 150 }))
      return
    }
    fillOpacity.set(
      withRepeat(
        withTiming(0.35, { duration: 700, easing: Easing.inOut(Easing.ease) }),
        -1,
        true
      )
    )
  }, [isPulsing, fillOpacity])

  const fillStyle = useAnimatedStyle(() => ({ opacity: fillOpacity.get() }))

  return (
    <View className={className}>
      <Animated.View
        className="h-full rounded-full bg-green-500"
        style={[{ width: `${Math.round(progress * 100)}%` }, fillStyle]}
      />
    </View>
  )
}
